import { render } from "./StepperRegister.vue?vue&type=template&id=5d96cfc5&scoped=true"
import script from "./StepperRegister.vue?vue&type=script&lang=js"
export * from "./StepperRegister.vue?vue&type=script&lang=js"

import "./StepperRegister.vue?vue&type=style&index=0&id=5d96cfc5&scoped=true&lang=css"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d96cfc5"]])

export default __exports__